import React, {useEffect} from 'react';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';

import { fetchLinkolnEmails } from '../store/resources';
import CopyModal from './CopyModal';
import LinkolnEmail from './LinkolnEmail';


export default function LinkolnEmails() {
  const dispatch = useDispatch();
  const linkoln_emails = useSelector(state => state.linkolnEmails);
  const domain = useSelector(state => state.app.current_domain);

  useEffect(() => {
    dispatch(fetchLinkolnEmails(domain));
  }, [dispatch, domain]);

  return (
    <div className="container px-0">
        <div className="row">
        <div className="col-12">
        <h2>Messages</h2>
        <h3>It’s time to create your very own LINKOLN Email!</h3>
        Just send an email to: <a href="mailto:create@linkoln.email">create@linkoln.email</a>
        <p>Seriously, it can be anything you like, your pet's name, your favorite food, you name it! This ain't your grandma's email setup – no forms, no fuss.</p>
        <p>Just a single email, and your unique LINKOLN Email link is ready to rock. Hit us up, let's turn 'anything' into your extraordinary</p>
        <p>Simplify your communication with secure message links. No more complicated email threads or inboxes. Just simple and secure message links that anyone can use. </p>

        <Table striped bordered responsive>
          <tbody>
          {linkoln_emails.map(linkoln_email => (
            <LinkolnEmail
              linkoln_email={linkoln_email}
              key={linkoln_email.linkoln_email_id}
            />
          ))}
          </tbody>
        </Table>
        <CopyModal/>
        <p><strong>Coming soon…</strong> individual message history and activity reporting.</p>
      </div>
      </div>
    </div>
  );
}
